export class FiltrosRepMarketing{
   
    Usuario : string ='';
    Estado: string = '';
    Tipo: string = 'empresa_cliente';
   idEmpresa: string = '4';
 
 }